<template>
  <div class="mpc-wrapper">
    <call-test-list :data="items" :server-ip="dataParams.ip" :server-port="dataParams.serverport">
      <template #actions>
        <instruction-btn
          :id="instruction.excellent.mpc.id"
          tool-tip-placement="right"
          :instruction-info="instruction.excellent.mpc.instructionInfo"
        ></instruction-btn>
      </template>
    </call-test-list>
    <call-test-dialog ref="callTestDialog"></call-test-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import instruction from '@/instruction/index'
import callTestList from './callTestList.vue'
import callTestDialog from './callTestDialog.vue'
import genKeyIcon from '@/assets/images/excellent/gen-key-icon.png'
import encipherIcon from '@/assets/images/excellent/encipher-icon.png'
import decryptIcon from '@/assets/images/excellent/decrypt-icon.png'

export default {
  name: 'Mpc',
  components: {
    callTestList,
    callTestDialog
  },
  props: {
    dataObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      dataParams: {},
      items: [
        {
          name: '生成密钥',
          url: '/encrypt/mpc/generate',
          ip: '',
          port: '',
          icon: genKeyIcon,
          title: '多方安全计算生成密钥',
          formItems: [
            {
              prop: 'threshold',
              label: '门陷',
              type: 'number'
            },
            {
              prop: 'total',
              label: '总数',
              type: 'number',
              max: 10
            }
          ],
          formRules: {},
          formModel: {
            threshold: 0,
            total: 0
          },
          btns: [
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.genKey
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '加密计算',
          url: '/encrypt/mpc/encrypt',
          ip: '',
          port: '',
          icon: encipherIcon,
          title: '多方安全计算加密计算',
          formItems: [
            {
              prop: 'pubKey',
              label: '公钥',
              type: 'textarea',
              secret: true,
              placeholder: '请输入公钥',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'text',
              label: '明文',
              type: 'textarea',
              placeholder: '请输入要加密的内容',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '加密文本',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            pubKey: undefined,
            text: undefined,
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.encipher
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '解密计算',
          url: '/encrypt/mpc/decrypt',
          icon: decryptIcon,
          title: '多方安全计算解密计算',
          formItems: [
            {
              prop: 'keys',
              label: '私钥',
              type: 'textarea',
              isArray: true,
              secret: true,
              placeholder: '请输入私钥',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'CipherText',
              label: '密文',
              type: 'textarea',
              secret: true,
              placeholder: '请输入要加密的内容',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '加密文本',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            keys: [{ value: '' }],
            CipherText: undefined,
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '添加私钥',
              click: (formRef, closeCal, getModel, item, data) => {
                data.formModel.keys.push({})
              }
            },
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.decrypt
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        }
      ],
      instruction
    }
  },
  created() {
    this.dataParams = this.dataObj
  },
  methods: {
    callTestHandle(data) {
      data.ip = this.dataParams.ip
      data.port = this.dataParams.serverport
      this.$refs.callTestDialog.handleOpen(data)
    },
    genKey(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          let model = getModel()
          console.log(model)
          if (parseInt(model.total) >= parseInt(model.threshold)) {
            item.isLoading = true
            let params = JSON.stringify(model)
            axios({
              method: 'POST',
              url: `http://${data.ip}:${data.port}${data.url}`,
              data: params,
              responseType: 'arraybuffer'
            })
              .then(res => {
                let blob = new Blob([res.data], {
                  type: 'application/zip'
                })
                let url = window.URL.createObjectURL(blob)
                const link = document.createElement('a') // 创建a标签
                link.href = url
                link.download = 'Mpckeys' // 重命名文件
                link.click()
                URL.revokeObjectURL(url) // 释放内存
                self.$message.success(
                  `生成密钥成功...,后续解密私钥数量须和门陷数量一致，并且须要连贯的${model.threshold}个私钥`
                )
                item.isLoading = false
                closeCal()
              })
              .catch(err => {
                self.$message.error(`生成密钥失败！`)
                item.isLoading = false
              })
          } else {
            self.$message.error('门陷数量不能大于总数数量，请重新输入！')
          }
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    encipher(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formEncrypt(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.cipherText
                data.displayState['display'] = false
                self.$message.success('加密成功！')
              } else {
                self.$message.error('加密失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('加密失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    decrypt(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let keys = model.keys.map(e => e.replace(/[\r\n]/g, ''))
          model.keys = keys
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formDecrypt(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.text
                data.displayState['display'] = false
                self.$message.success('解密成功！')
              } else {
                self.$message.error('解密失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('解密失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
